export const REQUEST_CAMPAIGN_PAYMENT_LIST = "REQUEST_CAMPAIGN_PAYMENT_LIST"